export enum ProductFamilyIds {
  Opportunities = "opportunities",
  PhoneSystem = "phone-system",
}

export enum PhoneSystemProductIds {
  Starter = "phone-system-starter",
  Elevate = "phone-system-elevate",
  Enterprise = "phone-system-enterprise",
}
